import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { getWorkroomById } from '../../../../../../reducers';
import { IconButton } from 'react-toolbox';
import WorkroomType from 'types/workroom';
import S from 'styles.scss';

const ReportHeaders = ({ workroom, printable }) =>
  <header className={cx(S.header, { [S.printable]: printable })}>
    <h4 className={S.title}>{workroom && `${workroom.name} Workroom`}</h4>
    <IconButton icon="print" className={S.print} onClick={window.print} />
  </header>;

ReportHeaders.propTypes = {
  workroom: WorkroomType,
  printable: PropTypes.bool.isRequired,
};

ReportHeaders.defaultProps = {
  printable: true,
};

export default connect((state, ownProps) => ({
  workroom: getWorkroomById(state)(ownProps.workroom),
}))(ReportHeaders);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/components/ReportHeaders/index.jsx